import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";

import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";
export class ViewLRDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:'hello',
            lrInfo:[]
        };
    }
    handleOpenEdit = () => {
        console.log("open edit");
        console.log("this.props",this.props.data)
        // this.props.agGridReact.props.getRowLRDetails(this.props.data)
        allAxiosCommonRequest({
            url: "lr/get",
            method: "post",
            Items: {
              lrNo: this.props.data.lr_no,
            },
          })
            .then((response) => {
                // console.log("response",response.data.data);
            //   this.setState({ lrInfo: response.data.data });
              this.props.agGridReact.props.getRowLRDetails(response.data.data);
            }
            )
            .catch((err) => {
              console.log(err);
            });
    };

    render() {
        return (
            <>
                <Button
                    onClick={this.handleOpenEdit}
                    basic
                    size="mini"
                    type="button"
                    icon
                >
                    {" "}
                    <Icon name="eye" color="green" />
                </Button>
            </>
        );
    }
}

export default ViewLRDetails;
